import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startSending, endSending, startLoading, endLoading } from "../progress/pogressSlice";
import { setAlert } from "../alert/alertSlice";
import { closeModal } from "../modal/modalSlice";
import * as api from '../../api';
import { formErrors, serverErrors } from "../";

const initialState = {
    isActive: false,
    event: { id: '', nombre: '', responsable: '', tipo: '', fecha: '', hora: '', lugar: '', encargado: ''},
    community: [],
    guests: [],
    attendance: {
        alumnos: 0,
        egresados: 0,
        profesores: 0,
        administrativos: 0,
        externos: 0,
        total: 0
    }
}

const dir = 'records';

export const singlePost = async(dispatch, values, setError, navigate, setSuccess, setUser) => {
    dispatch(startSending())
    try {
        const { data } = await api.createNew(dir, values);
        dispatch(endSending());
        setSuccess(true);
        return setUser(data);
    } catch (error) {
        console.log(error);
        dispatch(endSending())
        if(error.response.data.id){
            dispatch(setAlert({ title: 'Error!', msg: error.response.data.id, severity: 'error' }))
            return navigate('/')
        }
        return dispatch(formErrors(error.response, setError));
    }
}

export const getEventInfo = async(dispatch, id, navigate, setData, setStatus) => {
    dispatch(startLoading())
    try {
        const { data } = await api.getData(`${dir}/event/${id}`);
        dispatch(endLoading());
        setData(data);
        return setStatus('succeeded')
    } catch (error) {
        console.log(error);
        dispatch(endLoading())
        if(error.response.data.id){
            dispatch(setAlert({ title: 'Error!', msg: error.response.data.id, severity: 'error' }))
            return navigate('/')
        }
    }
}

export const eventIsActive = createAsyncThunk('records/check', async ({ id, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        const { data } = await api.getData(`${dir}/${id}`)
        thunkAPI.dispatch(endSending())
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue();
    }
})

export const addUser = createAsyncThunk('records/addUser', async ({ values, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        const { data } = await api.createNew(dir, values);
        document.getElementById('form').reset();
        thunkAPI.dispatch(setAlert({ title: 'Bienvenido!', msg: data.nombre, severity: 'success' }))
        thunkAPI.dispatch(endSending());
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue();
    }
})

export const deleteUser = createAsyncThunk('records/deleteUser', async({ id }, thunkAPI) => {
    thunkAPI.dispatch(startSending());
    try {
        await api.deleteItem(dir, id)
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal());
        return id
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending))
        return thunkAPI.rejectWithValue();
    }
})

export const addGuest = createAsyncThunk('records/addGuest', async ({ values, setError, clearForm }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        const { data } = await api.createNew(`${dir}/outer`, values);
        document.getElementById('form').reset();
        clearForm()
        thunkAPI.dispatch(setAlert({ title: 'Bienvenido!', msg: data.nombre, severity: 'success' }))
        thunkAPI.dispatch(endSending());
        return data;
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))   
        return thunkAPI.rejectWithValue();
    }
})

export const deleteGuest = createAsyncThunk('records/deleteGuest', async({ id }, thunkAPI) => {
    thunkAPI.dispatch(startSending());
    try {
        await api.deleteItem(`${dir}/outer`, id)
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal());
        return id
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending))
        return thunkAPI.rejectWithValue();
    }
})

export const recordSlice = createSlice({
    name: 'record',
    initialState,
    reducers: {
        newEvent: (state) => initialState
    },
    extraReducers(builder){
        builder
            .addCase(addUser.fulfilled, (state, action) => {
                switch (action.payload.tipo) {
                    case 1:
                        state.attendance.alumnos+=1;
                        break;
                    case 2:
                        state.attendance.egresados+=1;
                        break;
                    case 4:
                        state.attendance.profesores+=1;
                        break;
                    case 5:
                        state.attendance.administrativos+=1;
                        break;
                    default:
                        break;
                }
                state.attendance.total += 1;
                state.community = [action.payload, ...state.community];
            })
            .addCase(deleteUser.fulfilled, (state, action) => {
                const { tipo } = state.community.find(el => el.id === action.payload);
                switch (tipo) {
                    case 1:
                        state.attendance.alumnos-=1;
                        break;
                    case 2:
                        state.attendance.egresados-=1;
                        break;
                    case 4:
                        state.attendance.profesores-=1;
                        break;
                    case 5:
                        state.attendance.administrativos-=1;
                        break;
                    default:
                        break;
                }
                state.attendance.total -= 1;
                state.community = state.community.filter(el => el.id !== action.payload);
            })
            .addCase(addGuest.fulfilled, (state, action) => {
                state.attendance.total += 1;
                state.attendance.externos += 1;
                state.guests = [action.payload, ...state.guests];
            })
            .addCase(deleteGuest.fulfilled, (state, action) => {
                state.attendance.total-=1;
                state.attendance.externos-=1
                state.guests = state.guests.filter(el => el.id !== action.payload)
            })
            .addCase(eventIsActive.fulfilled, (state, action) => {
                return { isActive: true, ...action.payload }
            })
    }
})

export const { newEvent } = recordSlice.actions;

export default recordSlice.reducer;